<template>
  <div class="chart-wrapper">
    <div class="chart-container">
      <component
        :is="chartComponent"
        ref="chartBody"
        :key="chartBodyKey"
        :message="message"
      ></component>
    </div>
  </div>
</template>
<script>
import moment from "moment"
// Lazy-load chart and mermaid components so heavy deps (vue-google-charts, mermaid) load only when needed
export default {
  name: "ChatMessageChart",
  props: {
    message: {
      type: Object,
      required: true,
    },
    displaySubType: {
      type: String,
      default: null,
    },
  },
  components: {
    ChatMessagePie: () => import("./charts/ChatMessagePie.vue"),
    ChatMessageBar: () => import("./charts/ChatMessageBar.vue"),
    ChatMessageLine: () => import("./charts/ChatMessageLine.vue"),
    MermaidDiagram: () => import("./charts/MermaidDiagram.vue"),
  },
  computed: {
    effectiveDisplaySubType() {
      const p = this.displaySubType
      if (p === "pie" || p === "bar" || p === "line" || p === "mermaid") {
        return p
      }
      const st = this.message.display && this.message.display.sub_type
      if (st === "pie" || st === "bar" || st === "line" || st === "mermaid") {
        return st
      }
      return "bar"
    },
    chartComponent() {
      switch (this.effectiveDisplaySubType) {
        case "pie":
          return "ChatMessagePie"
        case "bar":
          return "ChatMessageBar"
        case "line":
          return "ChatMessageLine"
        case "mermaid":
          return "MermaidDiagram"
        default:
          return "ChatMessageBar"
      }
    },
    chartBodyKey() {
      const id = this.message && this.message.id != null ? this.message.id : "chart"
      return `${id}-${this.effectiveDisplaySubType}`
    },
  },
  methods: {
    async downloadChartImage() {
      const body = this.$refs.chartBody
      if (!body || typeof body.exportChartImage !== "function") {
        return
      }
      let uri = body.exportChartImage()
      if (uri && typeof uri.then === "function") {
        uri = await uri
      }
      if (!uri) {
        await this.$nextTick()
        await new Promise(function (r) {
          setTimeout(r, 150)
        })
        uri = body.exportChartImage()
        if (uri && typeof uri.then === "function") {
          uri = await uri
        }
      }
      if (!uri) {
        return
      }
      const link = document.createElement("a")
      link.href = uri
      link.download = `caseblocks-chart-${moment().format("YYYY-MM-DD-HHmmss")}.png`
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
  },
}
</script>

<style lang="scss" scoped>
.chart-wrapper {
  width: 100%;
}

.chart-container {
  width: 100% !important;
}
</style>
